import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import PreventiviList from './pages/PreventiviList';
import PreventivoEditor from './pages/PreventivoEditor';
import PreventivoView from './pages/PreventivoView';
import LoginPage from './pages/LoginPage';
import { authApi } from './api/client';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    // Verifica il token con il server
    const verifyAuth = async () => {
      try {
        // Controlla prima se c'è un token salvato
        if (!authApi.isAuthenticated()) {
          setIsAuthenticated(false);
          setIsChecking(false);
          return;
        }
        
        // Verifica il token con il server
        const response = await authApi.verify();
        if (response.data.valid) {
          setIsAuthenticated(true);
        } else {
          // Token non valido - pulisci
          authApi.logout();
          setIsAuthenticated(false);
        }
      } catch (error) {
        console.error('Auth verification error:', error);
        authApi.logout();
        setIsAuthenticated(false);
      } finally {
        setIsChecking(false);
      }
    };
    
    verifyAuth();
  }, []);

  const handleLogin = () => {
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    authApi.logout();
    setIsAuthenticated(false);
  };

  // Mostra un loader mentre controlla l'autenticazione
  if (isChecking) {
    return (
      <div className="min-h-screen bg-gray-900 flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  // Se non autenticato, mostra la pagina di login
  if (!isAuthenticated) {
    return <LoginPage onLogin={handleLogin} />;
  }

  // Se autenticato, mostra l'app normale
  return (
    <Router>
      <Layout onLogout={handleLogout}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/preventivi" element={<PreventiviList />} />
          <Route path="/preventivi/nuovo" element={<PreventivoEditor />} />
          <Route path="/preventivi/:id/edit" element={<PreventivoEditor />} />
          <Route path="/preventivi/:id" element={<PreventivoView />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
